import TagList from '../../../ui/molecules/TagList';
import { formatTagLabel } from '../labels/sessionLabels';

const AnalysisTagList = (props) => (
  <TagList formatLabel={formatTagLabel} {...props} />
);

export default AnalysisTagList;
